import { render } from "./ContentQuote.vue?vue&type=template&id=08d60e26"
import script from "./ContentQuote.vue?vue&type=script&lang=js"
export * from "./ContentQuote.vue?vue&type=script&lang=js"

import "./ContentQuote.vue?vue&type=style&index=0&id=08d60e26&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__